module.exports = __webpack_public_path__ + "site/img/203.3301040f.jpg";